import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  insight_zone_logo: require("../../../assets/wc/images/insight_zone_white.png"),
  right_arrow: require("../../../assets/svg/arrow-right.svg"),
};

export default assets;
